export default {
    'InsertUnameEmail':     'Insert username or email',
    'ChangePass':           'Change password',
    'UnameOrEmail':         'Username or email',
    'PassRecover':          'Recover password',
    'InsertCurrPass':       'Insert the current password',
    'CurrentPass':          'Current password',
    'NewPass':              'New password',
    'CreateNewPass':        'Create new password',
    'ConfirmNewPass':       'Confirm new password',
    'show_pass':            'Show password',
    'hide_pass':            'Hide password',
    'RequiredField':        'This field is required',
    'PassDontMatch':        'Passwords don\'t match',
    'PassReq1':             'It can\'t be too common',
    'PassReq2':             'It must contain at least 12 characters',
    'PassReq3':             'It cannot be entirely numeric',
    'SuccessMailSent':      'An email has been sent to the address (or user) provided, follow the directions in the email to reset your password',
    'SuccessMailSent2':     'If you do not receive the message within a few moments, please contact system administrator',
    'SuccessPassReset':     'You have successfully changed your password',
    'Send':                 'Send',
    'UnknownError':         'Unexpected error, please try again or contact system administrator.',
    'Language':             'Language'
}
